export default __webpack_public_path__ + "static/media/ic_guinea_bissau.d9b2c7b2.svg";